import React, { useCallback, useEffect, useState } from 'react';
import AppLayout from '../../components/ui/AppLayout';
import PageHeader from '../../components/ui/PageHeader';
import LoadingState from '../../components/ui/LoadingState';
import CheckinEquipe from '../../components/CheckinEquipe';
import RankingGoleiros from '../../components/RankingGoleiros';
import { useAuth } from '../../AuthContext';
import api from '../../api';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import tokens from '../../theme/tokens';
import { dataPelada } from '../../utils/dataPelada';

// Tela do goleiro: check-in na pelada em que foi escalado e ranking de goleiros da temporada.
const GoleiroPage = () => {
  const { userLogado } = useAuth();
  const [escala, setEscala] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [ranking, setRanking] = useState(null);
  const [avaliacao, setAvaliacao] = useState(null); // última avaliação de pelada em que foi escalado
  const navigate = useNavigate();

  const carregar = useCallback(async () => {
    try {
      const response = await api.get('equipe/minha-escala');
      setEscala(response.data);
    } catch (error) {
      setEscala({ pelada: null });
    }
    setCarregando(false);
  }, []);

  useEffect(() => {
    carregar();
    api.get('goleiros/ranking').then((r) => setRanking(r.data)).catch(() => setRanking({ goleiros: [] }));
    api.get('avaliacoes/ultima').then((r) => setAvaliacao(r.data.pelada)).catch(() => {});
  }, [carregar]);

  return (
    <AppLayout maxWidth="sm">
      <PageHeader eyebrow="Goleiro" title={`Olá, ${(userLogado?.nome || '').split(' ')[0]}`} subtitle="Faça o check-in ao chegar na pelada." />
      {carregando ? <LoadingState /> : <CheckinEquipe escala={escala} papel="goleiro" onCheckin={carregar} />}
      {avaliacao && (
        <Card sx={{ p: 2, mt: 3, borderColor: avaliacao.avaliacao?.status === 'aberta' ? tokens.color.gold : 'divider' }}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <StarRoundedIcon sx={{ fontSize: 36, color: tokens.color.gold }} />
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
              <Typography fontWeight={700}>Avaliação da pelada</Typography>
              <Typography variant="body2" color="text.secondary">
                {dataPelada(avaliacao.date, { weekday: 'long', day: '2-digit', month: 'long' })} ·{' '}
                {avaliacao.avaliacao?.status === 'aberta' ? 'aberta — dê suas estrelas aos jogadores' : 'encerrada'}
              </Typography>
            </Box>
            <Button variant={avaliacao.avaliacao?.status === 'aberta' ? 'contained' : 'outlined'} onClick={() => navigate(`/avaliacao/${avaliacao._id}`)}>
              {avaliacao.avaliacao?.status === 'aberta' ? 'Avaliar' : 'Ver resultado'}
            </Button>
          </Stack>
        </Card>
      )}
      {ranking && (
        <RankingGoleiros
          goleiros={ranking.goleiros}
          destaque={userLogado?._id}
          subtitle={`Temporada ${ranking.ano || new Date().getFullYear()} · menor média de gols sofridos por pelada`}
          sx={{ mt: 3 }}
        />
      )}
    </AppLayout>
  );
};

export default GoleiroPage;
